// modal functions
// include the close modal functions
function closeModal() {
    $('.overlay, .modal, .admin-overlay').removeClass('visible');
}

$('body').click(function(e){
    if($(e.target).attr('class') === 'overlay visible' || $(e.target).attr('class') === 'admin-overlay visible') {
        closeModal();
    }
});

$(document).keyup(function(e) {
    if (e.keyCode === 27) { // Esc
        closeModal();
    }
});

// $(document).keyup(function(e) {
//     if (e.keyCode ===13) { // Esc
//         if($('.modal.display-notice').hasClass('visible')) {
//             console.log('close modal');
//             $('.modal a.close-error').trigger('click');
//             // closeModal();
//             e.preventDefault();
//             return false;
//         }
//     }
// });


$('body').on('click', '.modal a.close', function() {
    closeModal();        
    return false;
});

$('body').on('click', '.ignore', function() {
    return false;
});

function showNotice(header, message, button) {
    var scrollTop = $(window).scrollTop();
    $('.display-notice').css({
        'top': (scrollTop-500)+'px'
    });
    
    $('.display-notice h6').html(header);
    $('.display-notice .notice-message').html(message);
    $('.display-notice .button').html(button);
    $('.overlay, .modal.display-notice').addClass('visible');
}

$('body').on('click', '.modal a.close-error', function() {
    if($('.modal.visible').length === 1) {
        $('.display-notice, .overlay').removeClass('visible');
    } else {
        $('.display-notice').removeClass('visible');
    }
    
    return false;
});


function loading(text) {
    text = (typeof(text) === 'undefined') ? 'Loading...' : text;
    $('.loading-overlay, .loading').addClass('visible');
    $('.loading span').html(text);
}

function unloading() {
    $('.loading-overlay, .loading').removeClass('visible');
}